// extracted by mini-css-extract-plugin
export default {"how":"Creatingemb_how__qtU4e","banner":"Creatingemb_banner__gCJmU"};